import React, { useState } from "react";
import { toast } from "react-toastify";
import { get } from "lodash";
import ConfirmationModal from "../../../Common/ConfirmationModal";
import { deleteMlQcRuleSpecific } from "../../../../actions/qc";

export default function RuleDeleteConfirmationSpecific({
  data,
  onConfirm,
  onCancel,
  objKey = "_id",
}) {
  const [loading, setLoading] = useState(false);

  const id = get(data, objKey);

  /**
   * handles clicking confirm
   */
  const handleOnConfirm = async () => {
    setLoading(true);
    const response = await deleteMlQcRuleSpecific(id);
    setLoading(false);
    if (response.success) {
      toast.success(response.message || "Customer rule deleted successfully");
      if (onConfirm) onConfirm();
    } else {
      toast.error(response.message || "Something went wrong!");
    }
  };

  return (
    <ConfirmationModal
      open
      title="Delete Customer Rule"
      bodyComponent={() => (
        <div>
          You are about to delete customer rule for
          {" "}
          <strong>{data?.customer_id}</strong>
          {data?.sample_info?.sample_type && (
            <>
              {" "}
              with sample type
              {" "}
              <strong>{data.sample_info.sample_type}</strong>
            </>
          )}
        </div>
      )}
      okText="Delete"
      cancelText="Cancel"
      onOk={handleOnConfirm}
      onCancel={onCancel}
      loading={loading}
    />
  );
}
